module.exports = __webpack_public_path__ + "a86f97d820b11bed1567624882cb754c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/backgrounds/cover-2.jpg
// module id = 392
// module chunks = 0